import React from 'react';

import Img from '@common/Image';
import Link from '@common/Link';
import Heading from '@common/Heading';
import Row from '@common/Row';

const Tile = ({ data }) => {
  const {
    title,
    subtitle,
    link,
    media,
    date
  } = data;
  return (
    <Link to={link} className={`no-hover`}>
      <Row className='py-4 w-100 mx-auto border-top border-2 border-black'>
        <div className={`col-12 col-md-8`}>
          <div className={`d-flex mb-2`}>
            {subtitle && <p className={`text-uppercase text-blue fw-semibold`}>{subtitle}</p>}
            {date && <p className={`ps-1`}>{`| ${date}`}</p>}
          </div>
          {title && <Heading type='h3' className={`h4 text-black show-hover`}>{`${title} ➜`}</Heading>}
        </div>
        {media &&
          <div className={`col-3 d-none d-lg-block`}>
            <Img image={media.gatsbyImageData} file={media.file} alt={media.description} />
          </div>
        }
      </Row>
    </Link>
  )
}

export default Tile
